export const SEARCH_BANNER_DEFAULTS = {
  query: 'Racing gear',
  placeholder: 'Search listings, parts, experiences…',
  tabs: ['Shop', 'Book', 'Partner'],
  activeTab: 'Shop',
};

export const SEARCH_FILTER_GROUPS = [
  {
    id: 'category',
    title: 'Category',
    type: 'checkbox',
    options: [
      { id: 'apparel', label: 'Apparel', count: 3, checked: true },
      { id: 'parts', label: 'Parts', count: 4, checked: true },
      { id: 'collectibles', label: 'Collectibles', count: 2, checked: false },
      { id: 'accessories', label: 'Accessories', count: 0, checked: false },
    ],
  },
  {
    id: 'price',
    title: 'Price Range',
    type: 'price',
  },
  {
    id: 'location',
    title: 'Location',
    type: 'checkbox',
    options: [
      { id: 'concord', label: 'Concord, NC', checked: false },
      { id: 'charlotte', label: 'Charlotte, NC', checked: false },
      { id: 'mooresville', label: 'Mooresville, NC', checked: false },
      { id: 'indianapolis', label: 'Indianapolis, IN', checked: false },
    ],
  },
  {
    id: 'rating',
    title: 'Min Rating',
    type: 'rating',
    options: [
      { id: '4', filledStars: 4, checked: false },
      { id: '3', filledStars: 3, checked: true },
    ],
  },
  {
    id: 'seller',
    title: 'Seller Type',
    type: 'checkbox',
    options: [
      { id: 'verified', label: 'Verified Members', count: 7, checked: true },
      { id: 'all', label: 'All Sellers', count: 9, checked: false },
    ],
  },
];

export const SEARCH_ACTIVE_FILTERS = ['Apparel', 'Parts', '3+ Stars'];

export const SEARCH_RESULTS_META = {
  count: 9,
  query: 'Racing gear',
  sortOptions: ['Featured', 'Newest', 'Price: Low → High', 'Price: High → Low', 'Top Rated'],
  activeSort: 'Featured',
};

export const SEARCH_LISTINGS = [
  {
    id: 'hoodie',
    department: 'shop',
    tag: 'Apparel',
    image:
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=600&q=70',
    imageAlt: 'Official Team Hoodie',
    title: 'Official Team Hoodie',
    subtitle: 'Switch Off Racing · ✓ Verified',
    price: '$89.00',
    location: 'Concord, NC',
    rating: 4.8,
    reviewCount: 34,
    filledStars: 5,
  },
  {
    id: 'splitter',
    department: 'shop',
    tag: 'Parts',
    image:
      'https://images.unsplash.com/photo-1611241893603-3c359704e0ee?auto=format&fit=crop&w=600&q=70',
    imageAlt: 'Carbon Fibre Splitter Kit',
    title: 'Carbon Fibre Splitter Kit',
    subtitle: 'Apex Composites · ✓ Verified',
    price: '$1,240.00',
    location: 'Charlotte, NC',
    rating: 4.9,
    reviewCount: 18,
    filledStars: 5,
  },
  {
    id: 'brakes',
    department: 'shop',
    tag: 'Parts',
    image:
      'https://images.unsplash.com/photo-1614026480218-a9879a0c8b96?auto=format&fit=crop&w=600&q=70',
    imageAlt: 'Race-Spec Brake Caliper Set',
    title: 'Race-Spec Brake Caliper Set',
    subtitle: 'GreenFlag Parts',
    price: '$2,150.00',
    location: 'Indianapolis, IN',
    rating: 4.7,
    reviewCount: 11,
    filledStars: 4,
  },
  {
    id: 'cap',
    department: 'shop',
    tag: 'Apparel',
    image:
      'https://images.unsplash.com/photo-1620188467120-5042ed1eb5da?auto=format&fit=crop&w=600&q=70',
    imageAlt: 'Team Pit Crew Cap',
    title: 'Team Pit Crew Cap',
    subtitle: 'Switch Off Racing · ✓ Verified',
    price: '$34.00',
    location: 'Concord, NC',
    rating: 4.6,
    reviewCount: 52,
    filledStars: 4,
  },
  {
    id: 'helmet',
    department: 'shop',
    tag: 'Collectibles',
    image:
      'https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f?auto=format&fit=crop&w=600&q=70',
    imageAlt: 'Signed Driver Helmet Replica',
    title: 'Signed Driver Helmet Replica',
    subtitle: 'Backline Motorsports · ✓ Verified',
    price: '$450.00',
    location: 'Mooresville, NC',
    rating: 5.0,
    reviewCount: 7,
    filledStars: 5,
  },
  {
    id: 'wing',
    department: 'shop',
    tag: 'Parts',
    image:
      'https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?auto=format&fit=crop&w=600&q=70',
    imageAlt: 'Adjustable Wing Assembly',
    title: 'Adjustable Wing Assembly',
    subtitle: 'Downforce Labs · ✓ Verified',
    price: '$3,800.00',
    location: 'Shawano, WI',
    rating: 4.7,
    reviewCount: 9,
    filledStars: 4,
  },
  {
    id: 'gloves',
    department: 'shop',
    tag: 'Apparel',
    image:
      'https://images.unsplash.com/photo-1519764622345-23439dd774f7?auto=format&fit=crop&w=600&q=70',
    imageAlt: 'Nomex Racing Gloves',
    title: 'Nomex Racing Gloves — Medium',
    subtitle: 'Apex Safety Co.',
    price: '$195.00',
    location: 'Phoenix, AZ',
    rating: 4.8,
    reviewCount: 29,
    filledStars: 5,
  },
  {
    id: 'livery',
    department: 'shop',
    tag: 'Parts',
    image:
      'https://images.unsplash.com/photo-1546198632-9ef6368bef12?auto=format&fit=crop&w=600&q=70',
    imageAlt: 'Custom Livery Door Graphics',
    title: 'Custom Livery Door Graphics',
    subtitle: 'FullThrottle Print · ✓ Verified',
    price: '$125.00',
    location: 'Las Vegas, NV',
    rating: 4.5,
    reviewCount: 43,
    filledStars: 4,
  },
  {
    id: 'diecast',
    department: 'shop',
    tag: 'Collectibles',
    image:
      'https://images.unsplash.com/photo-1595814433015-e6f5ce69614e?auto=format&fit=crop&w=600&q=70',
    imageAlt: 'Limited Edition Diecast 1:18',
    title: 'Limited Edition Diecast 1:18',
    subtitle: 'Grid Memorabilia · ✓ Verified',
    price: '$78.00',
    location: 'Daytona, FL',
    rating: 4.9,
    reviewCount: 61,
    filledStars: 5,
  },
];

export const SEARCH_PAGINATION = {
  currentPage: 1,
  pages: [1, 2, 3],
  trailingPage: 8,
  showEllipsis: true,
};
